import { SummaryRow } from '../../../../Summary/SummaryRow';
import { VQ } from '../../../../../store/student/types';
import { IVisaPrepForm } from '../../../../../types';
import { boolToYesNo } from '../../../../../utilities/formatting';

function VisaPrepUniEnrolmentStep3(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.APPLIED_THROUGH_UCAS}
        label={'Did you apply for your course through UCAS?'}
        value={boolToYesNo(props.appliedThroughUCAS)}
      />
      {props.appliedThroughUCAS ? (
        <SummaryRow
          className={'visa-summary'}
          key={VQ.UCAS_PIN}
          value={props.ucasPin}
          label={'What is your UCAS personal identification number?'}
        />
      ) : null}
    </>
  );
}

export default VisaPrepUniEnrolmentStep3;
